import {ServiceInfo} from "../entities/ServiceInfo";
import apiClient from "./http";
import {Response} from "../entities/Response";

export class ServiceInfoService {

    static async listServiceInfo() : Promise<ServiceInfo[]> {
        const response = await apiClient.get('/service/serviceInfo/list');
        return response.data;
    }

    static async getServiceInfo(request: {appKey: string, env: string}) : Promise<Response<ServiceInfo>> {
        return await apiClient.post('/service/serviceInfo/get', request);
    }

    static async listServers(request: {appKey: string, environment: string}) : Promise<Response<ServiceServerInfo[]>> {
        return await apiClient.post(`/service/serviceInfo/serverInfo/list`, request);
    }

    static async markActive(request: {appKey: string, environment: string, internalIp: string}) : Promise<Response<void>> {
        return await apiClient.post(`/service/serviceInfo/serverInfo/mark/active`, request);
    }

    static async markInactive(request: {appKey: string, environment: string, internalIp: string}) : Promise<Response<void>> {
        return await apiClient.post(`/service/serviceInfo/serverInfo/mark/inactive`, request);
    }

    static deleteServer(request: { environment: string; appKey: string; internalIp: string }) : Promise<Response<void>> {
        return apiClient.post(`/service/serviceInfo/serverInfo/unregister`, request);
    }
}